import clsx from "clsx";
import FadeTransition from "components/FadeTransition";
import EPButton from "components/UI/EPButton";
import { useFavoriteGames } from "hooks/swr/useFavoriteGames";
import useService from "hooks/useService";
import React from "react";
import { GameService } from "service/GameService";
import useAuthContext from "src/contexts/AuthContext";
import { epToast } from "utils/epToast";

import FavoritesActive from "/public/svgs/favorites-active.svg";
import FavoritesOutlined from "/public/svgs/favorites-outlined.svg";
const FAV_COLOR = "#F05228";
function AddToFavButton({ game, small = false, noBg = false }) {
  const { data, error, mutate, isLoading } = useFavoriteGames();
  const isFavorite = data?.find(g => g.game_id === game.game_id);
  const addToFavoriteApi = useService(GameService.addToFavorites);
  const removeFromFavoriteApi = useService(GameService.removeFromFavorites);
  const { authUser } = useAuthContext();
  async function handleAddToFavorite() {
    try {
      if (isFavorite) {
        await removeFromFavoriteApi.call(game.game_id);
      } else {
        await addToFavoriteApi.call(game.game_id);
      }
      mutate();
      epToast.info(
        {
          title: isFavorite
            ? `${game.title} removed from favorites`
            : `${game.title} added to favorites`,
        },
        {
          id: "AddToFavButton",
        }
      );
    } catch (error) {
      epToast.error("Something went wrong. Please try again later.");
    }
  }
  if (small)
    return authUser ? (
      <FadeTransition>
        <button
          aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
          variant="icon"
          onClick={handleAddToFavorite}
          className={clsx(
            "flex aspect-square w-full items-center justify-center gap-2 rounded-full  text-red-500",
            isFavorite
              ? clsx(
                  "hover:bg-primary-content/80 active:bg-primary-content/90",
                  noBg ? "bg-transparent" : "bg-primary-content"
                )
              : clsx(
                  "hover:bg-primary-content/50 active:bg-primary-content/70",
                  noBg ? "bg-transparent" : "bg-primary-content/10"
                )
          )}
        >
          {isFavorite ? (
            <span>
              <FavoritesActive height={20} width={20} />
            </span>
          ) : (
            <>
              <FavoritesOutlined
                height={20}
                width={20}
                style={{
                  color: noBg ? "#FFFFFF" : FAV_COLOR,
                }}
              />
            </>
          )}
        </button>
      </FadeTransition>
    ) : (
      <></>
    );
  return authUser ? (
    <EPButton
      variant="secondary"
      onClick={handleAddToFavorite}
      className={clsx(
        "min-w-md flex h-10 w-full min-w-[max-content] items-center justify-center gap-2 rounded-full text-sm md:px-4 md:py-2 md:text-base"
        // isFavorite && "cursor-default bg-transparent"
      )}
    >
      {isFavorite ? (
        <>
          <FavoritesActive height={20} width={20} />
          Added to favorites
        </>
      ) : (
        <>
          <FavoritesOutlined height={20} width={20} />
          Add to favorites
        </>
      )}
    </EPButton>
  ) : (
    <EPButton
      variant="secondary"
      disabled
      aria-label="Add to favorites"
      notReady
      className={
        "flex h-10 w-44 items-center justify-center gap-2 rounded-full text-sm  md:text-base"
      }
    ></EPButton>
  );
}

export default AddToFavButton;
